<ifr-page-title pageTitle="'LEFT_PANEL_DIAGNOSTICS' | translate "/>

<diagnostics/>
